module.exports = __webpack_public_path__ + "static/img/20013 (4).1bc2d00.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20013 (4).webp
// module id = dcfU
// module chunks = 14